export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    /**
     * @description 登录
     * @param {Object} data 登录携带的信息
     */
    SYS_USER_LOGIN: function SYS_USER_LOGIN() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/admin_user/login",
        method: "post",
        data: data
      });
    },
    getAdminUser: function getAdminUser() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/admin_user/get",
        method: "post",
        data: data
      });
    },
    getAdminUserInfo: function getAdminUserInfo() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/admin_user/getInfo",
        method: "get",
        params: {
          id: id
        }
      });
    },
    addAdmin: function addAdmin() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/admin_user/add",
        method: "post",
        data: data
      });
    },
    updateAdmin: function updateAdmin() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/admin_user/update",
        method: "post",
        data: data
      });
    },
    deleteAdmin: function deleteAdmin() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/admin_user/delete",
        method: "post",
        data: data
      });
    }
  };
});